import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';

import type { Results } from '@uncinc/react-searchkit/types';

import Button from '../../Button';
import Card from '../../Molecules/Card';
import { type SearchPromotedContentThemesHit } from '../types';

import './style.scss';

function getSubType(hit: SearchPromotedContentThemesHit) {
  if ('article_type' in hit) {
    return hit.article_type[0];
  }

  if ('download_type' in hit) {
    return hit.download_type[0];
  }

  if ('e_learning_type' in hit) {
    return hit.e_learning_type[0];
  }

  if ('event_type' in hit) {
    return hit.event_type[0];
  }

  if ('intervention_type' in hit) {
    return hit.intervention_type[0];
  }

  if ('research_type' in hit) {
    return hit.research_type[0];
  }
  if ('practical_example_type' in hit) {
    return hit.practical_example_type[0];
  }
  if ('tool_type' in hit) {
    return hit.tool_type[0];
  }

  return undefined;
}

const RenderItem = (hit: SearchPromotedContentThemesHit) => {
  const subType = getSubType(hit);
  const {
    title,
    created,
    summary,
    image_style_uri: imageStyleUri,
    type,
    url,
  } = hit;

  return (
    <Card
      title={title[0]}
      body={summary?.[0]}
      image={imageStyleUri?.[0]}
      type={type[0]}
      subType={subType}
      link={url[0]}
      created={created[0]}
    />
  );
};

const SearchPromotedContentThemesResults: React.FC<Omit<Results, 'renderItem'>> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('SearchPromotedContentThemes__Results', className);

  return (
    <SearchResultsInfinite
      {...restProps}
      className={classNames}
      renderItem={RenderItem}
      // eslint-disable-next-line react/no-unstable-nested-components
      showMoreButton={(buttonProps) => (
        <Button {...buttonProps} type="inverted">
          {t('components.search_promoted_content_themes.results.show_more')}
        </Button>
      )}
    />
  );
};

export default SearchPromotedContentThemesResults;
